<template>
  <div>
    <Search
      v-model="orderId"
      shape="round"
      placeholder="请输入订单ID"
      type="digit"
      left-icon
      maxlength="10"
    >
      <template #right-icon>
        <Button
          @click="onClickButton"
          size="small"
          type="primary"
          round
          color="#E9CD8D"
          style="font-size: 16px"
        >
          查询
        </Button>
      </template>
    </Search>

    <div style="display: flex; justify-content: center" class="CountDownBox">
      <Circle
        v-model:current-rate="currentRate"
        :rate="rate"
        color="#77e066"
        layer-color="#d8d8d8"
        :stroke-width="50"
        :speed="speed"
        size="250px"
        style="display: flex; justify-content: center; align-items: center"
      >
        <CountDown
          :time="time"
          style="margin-top: 23px"
          @finish="onFinish"
          :auto-start="false"
          ref="countDown"
        >
          <template #default="timeData">
            <div class="CountDown">
              {{ FormatTime(timeData.minutes, timeData.seconds) }}
            </div>
            <p style="margin-top: 33px">
              <Tag
                round
                :type="taskStatusClass"
                size="medium"
                style="padding: 4px 10px"
                >{{ taskStatus }}</Tag
              >
            </p>
            <Button
              type="primary"
              size="small"
              round
              v-if="orderData.taskStatus == 0"
              @click="onSubmit"
              >现在开始</Button
            >
            <!-- 引导用户邀请同学下单 -->
            <Button
              v-else-if="orderData.taskStatus == 1 || orderData.taskStatus == 2"
              type="primary"
              size="small"
              round
              color="linear-gradient(#EF5A72, #EE4857)"
              style="color: #fefafe; font-weight: bold"
              @click="showInviteGuide = true"
            >
              邀请同学下单赚佣金
            </Button>
            <VanDialog
              v-model:show="showInviteGuide"
              style="background-color: #f7d35d"
              :closeOnClickOverlay="true"
              :showConfirmButton="false"
            >
              <div style="position: relative">
                <img src="/invite_.png" style="width: 100%; margin-top: 10px" />
                <span class="invitePhone">{{ orderData.phone }}</span>
              </div>
              <div style="margin: 0 auto">
                <span style="font-size: 12px; color: #0000008f"
                  >❗️查询邀请数据在首页的右上角噢~</span
                >
                <Checkbox 
                  v-model="CheckboxChecked"
                  checked-color="#ee0a24"
                  icon-size="14px"
                  style="font-size: 12px; margin-top: 14px; margin-bottom: 5px"
                  >默认本次课群ID</Checkbox
                >
                <Button
                  type="primary"
                  size="large"
                  color="linear-gradient(#EF5A72, #EE4857)"
                  style="color: #fefafe; font-weight: bold; letter-spacing: 2px"
                  @click="showShare = true"
                >
                  立刻邀请同学下单
                </Button>
              </div>
            </VanDialog>
          </template>
        </CountDown>
      </Circle>
    </div>
    <!-- 邀请面板 -->
    <ShareSheet
      v-model:show="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <CellGroup inset>
      <Card
        style="background-color: white"
        :title="orderData.groupTitle"
        :desc="orderData.examTitle"
        :thumb="orderData.groupImg"
      >
        <template #price>
          <span style="color: #b5b5b5">{{ startTime }}</span>
        </template>
      </Card>
      <VanDialog
        v-model:show="showVerifyphone"
        title="请输入您手机号中缺失部分"
        show-cancel-button
        theme="round-button"
        :before-close="verifyPhone"
      >
        <Divider />
        <Row justify="center" align="center">
          <Col span="4" style="text-align: center"
            >{{ orderData.phone.split("****")[0] }} -</Col
          >
          <Col span="14">
            <!-- 密码输入框 -->
            <PasswordInput
              :value="verifyPhoneValue"
              :length="4"
              :mask="false"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
          /></Col>
          <Col span="4" style="text-align: center"
            >- {{ orderData.phone.split("****")[1] }}</Col
          >
        </Row>
        <Divider />
      </VanDialog>

      <Field label="目标时间" :model-value="ExamTimeToMin" readonly />
      <Field
        label="目标分数"
        :model-value="orderData.targetScore.toString() + '分'"
        readonly
      />
      <Field>
        <template #input>
          <Button
            size="small"
            color="linear-gradient(to right, #ff6034, #ee0a24)"
            round
            block
            @click="modifyOrder"
            v-if="orderData.taskStatus == 1 || orderData.taskStatus == 0"
          >
            修改订单
          </Button>
          <Button
            size="small"
            color="linear-gradient(to right, rgb(255 191 59), rgb(255 106 224))"
            round
            block
            @click="showJoinMember = true"
            v-if="orderData.taskStatus == 2"
          >
            💰 帮助同学考试小赚一笔 💰
          </Button>
          <VanDialog
            v-model:show="showJoinMember"
            title="加入店铺会员享9折优惠"
          >
            <img src="/member.jpg" style="width: 100%" />
          </VanDialog>
        </template>
      </Field>
      <Field>
        <template #input>
          <Button size="small" type="success" round block @click="OpenYiban"
            >前去查看</Button
          >
        </template>
      </Field>
    </CellGroup>
    <!-- 数字键盘 -->
    <NumberKeyboard
      v-model="verifyPhoneValue"
      :show="showKeyboard"
      @blur="showKeyboard = false"
      z-index="4001"
    />
    <!-- 弹出修改订单 -->
    <Popup
      v-model:show="showModifyOrderBox"
      round
      position="bottom"
      :style="{ height: '45%' }"
    >
      <p style="font-size: 22px; margin: 10 0; text-align: center">修改订单</p>
      <Divider />
      <p style="font-size: 16px; margin: 10 0; text-align: center">
        考试已开始时间:{{ TimeToMin(remaTimeCalc()) }}
      </p>
      <p
        style="
          padding: 5px 10px;
          margin: 0;
          font-size: 14px;
          text-align: center;
        "
      >
        左滑减少倒计时时间，右滑增加倒计时时间
      </p>
      <sliderParameterVue
        v-model:examTime="submitOrderParams.examTime"
        v-model:examScore="submitOrderParams.examScore"
        :key="submitOrderParams.examTime._min"
      ></sliderParameterVue>
      <Field>
        <template #input>
          <Button
            size="small"
            color="linear-gradient(to right, #ff6034, #ee0a24)"
            round
            block
            @click="modifyOrderConfirm"
          >
            修改订单
          </Button>
        </template>
      </Field>
    </Popup>
  </div>
</template>
<script setup>
import { ref, computed, watch, reactive } from "vue";
import {
  Search,
  Button,
  Circle,
  CountDown,
  Tag,
  CellGroup,
  Card,
  Field,
  Toast,
  Dialog,
  PasswordInput,
  NumberKeyboard,
  Col,
  Row,
  Divider,
  Popup,
  Checkbox,
  ShareSheet,
} from "vant";
import sliderParameterVue from "@/components/sliderParameter.vue";
import { useRouter } from "vue-router";
import { payService } from "@/service/payService";
import { formatDate } from "@/utils/date";
import { examService } from "@/service/examService.js";
import copy from "@/utils/copy";
const VanDialog = Dialog.Component;
const countDown = ref(null);
const router = useRouter();
const orderId = ref("");
const showVerifyphone = ref(false);
const showJoinMember = ref(false);
const verifyPhoneSuccess = ref(false);
const verifyPhoneValue = ref("");
const showKeyboard = ref(false);

// 邀请引导窗口
const showInviteGuide = ref(false);
const CheckboxChecked = ref(false);
const showShare = ref(false);
const options = [
  { name: "微信", icon: "wechat" },
  { name: "复制链接", icon: "link" },
];
// 分享链接窗口
const onSelect = (option) => {
  let shareUrl = `http://${document.domain}/?inviteCode=${
    orderData.value.userInviteCode
  }${CheckboxChecked.value ? `&groupID=${orderData.value.groupId}` : ""}`;
  if (option.name == "复制链接") {
    copy(shareUrl);
    Toast("复制成功");
  } else if (option.name == "微信") {
    copy(shareUrl);
    // 打开微信分享
    window.open("weixin://");
    Toast("微信分享1");
  }
  showShare.value = false;
};
// 倒计时
const rate = ref(0);
let Sec = 0; // 任务总时长15秒
let speed = ref(0);
let time = ref(0);
// 用户点击开始时间
const startTime = ref("");
const orderData = ref({
  groupTitle: "未知课群标题",
  examTitle: "未知考试标题",
  groupImg: "wechat.jpeg",
  targetScore: 100,
  targetExamTime: 60,
  maxScore: 100,
  maxExamTime: 1800,
  phone: "188****8888",
  groupId: "0",
  userInviteCode: "",
});
const currentRate = ref(0);
const examTimeValue = ref({
  _min: 0,
  _value: 1,
  _max: 100,
});
const examScoreValue = ref({
  _value: 1,
  _max: 100,
});

const submitOrderParams = reactive({
  examTime: {
    _min: 0,
    _value: 1,
    _max: 100,
  },
  examScore: {
    _value: 1,
    _max: 100,
  },
});

const showModifyOrderBox = ref(false);
// 时间处理
const timeCalc = () => {
  // 比对真实的时间
  let targetTime = new Date(orderData.value.targetDate);
  let nowTime = new Date();
  if (targetTime.getTime() - nowTime.getTime() < 0) {
    // 已完成
    orderData.value.taskStatus = 2;
  }
  // 计算开始时间
  if (orderData.value.taskStatus != 0) {
    // 目标日期减去目标时间得出开始时间
    let targetDate =
      new Date(orderData.value.targetDate.replace(/-/g, "/")).getTime() -
      orderData.value.targetExamTime;
    startTime.value = formatDate(targetDate);
  }
};

// 查询订单信息
const queryOrderInfo = (orderId) => {
  payService
    .query(orderId, 1)
    .then((res) => {
      if (res.state != "success") {
        throw res.result;
      }
      orderData.value = res.result;
      examTimeValue.value._max =
        orderData.value.maxExamTime - orderData.value.targetExamTime;
      examTimeValue.value._value = orderData.value.targetExamTime;
      examScoreValue.value._max = orderData.value.maxScore;
      examScoreValue.value._value = orderData.value.targetScore;
      // console.log(
      //   `MaxExamTime:${orderData.value.maxExamTime},MaxScore:${orderData.value.maxScore},TargetTime:${orderData.value.targetExamTime},TargetScore:${orderData.value.targetScore}`
      // );
      timeCalc();
    })
    .catch((errRes) => {
      Toast.fail({
        message: errRes,
        duration: 2000,
        forbidClick: true,
      });
    });
};

const ExamTimeToMin = computed({
  get() {
    const minute = Math.floor(orderData.value.targetExamTime / 60);
    const second = orderData.value.targetExamTime % 60;
    return `${minute}分${second}秒`;
  },
});
const taskStatus = computed({
  get() {
    switch (orderData.value.taskStatus) {
      case 0:
        return "未开始";
      case 1:
        return "进行中";
      case 2:
        return "已完成";
      default:
        return "未知状态";
    }
  },
});
const taskStatusClass = computed({
  get() {
    switch (orderData.value.taskStatus) {
      case 0:
        return "warning";
      case 1:
        return "success";
      case 2:
        return "primary";
      default:
        return "danger";
    }
  },
});
// 格式化倒计时时间
const FormatTime = (minutes, seconds) => {
  examTimeValue.value._min =
    parseInt(orderData.value.targetExamTime) -
    (parseInt(minutes) * 60 + parseInt(seconds));
  if (parseInt(minutes) < 10) {
    minutes = "0" + minutes.toString();
  }
  if (parseInt(seconds) < 10) {
    seconds = "0" + seconds.toString();
  }
  return minutes + ":" + seconds;
};
const onClickButton = () => {
  toCurrentPage(orderId.value);
  setTimeout(() => {
    location.reload();
  }, 0);
};
const toCurrentPage = (orderId) => {
  router.push(`/order/${orderId}`);
};
const OpenYiban = () => {
  window.open(`https://group.yooc.me/group/${orderData.value.groupId}/index`);
};
// 开始考试
const onSubmit = () => {
  const toast_ = Toast.loading({
    message: "提交考试...",
    forbidClick: true,
    duration: 0,
  });
  examService
    .submitExam(orderId.value)
    .then((resData) => {
      toast_.clear();
      if (resData.state == "success") {
        Toast.success({
          message: "提交成功",
          duration: 1000,
          onClose: () => location.reload(),
        });
      } else {
        Toast.fail({
          message: resData.result,
          duration: 2000,
        });
      }
    })
    .catch((err) => {
      // console.log(err);
      toast_.clear();
      Toast.fail({
        message: err,
        duration: 2000,
      });
    });
};
// 任务完成
const onFinish = () => {
  Toast.success({
    message: "考完啦～",
    duration: 1000,
    onClose: () => location.reload(),
  });
};
// 修改订单
const modifyOrder = () => {
  if (verifyPhoneSuccess.value == false) {
    // 需要手机号验证
    showVerifyphone.value = true;
  } else {
    showModifyOrderBox.value = true;
  }
};
// 确认修改订单
const modifyOrderConfirm = () => {
  const toast_ = Toast.loading({
    message: "修改订单...",
    forbidClick: true,
    duration: 0,
  });
  payService
    .modifyOrder(
      orderId.value,
      verifyPhoneValue.value,
      submitOrderParams.examTime._value,
      submitOrderParams.examScore._value
    )
    .then((resData) => {
      toast_.clear();
      if (resData.data.result) {
        Toast.success({
          message: "修改成功",
          duration: 1000,
          onClose: () => location.reload(),
        });
      } else {
        Toast.fail({
          message: resData.data.result,
          duration: 2000,
        });
      }
    })
    .catch((err) => {
      toast_.clear();
      Toast.fail({
        message: err,
        duration: 2000,
      });
    });
};
const verifyPhone = (action) => {
  if (action == "cancel") return true;
  payService
    .verifyPhone(orderId.value, verifyPhoneValue.value)
    .then((res) => {
      if (res.data.result != true) {
        Toast.fail(res.data.result);
        verifyPhoneValue.value = "";
        return false;
      }
      showVerifyphone.value = false;
      showModifyOrderBox.value = true;
      verifyPhoneSuccess.value = true;
      return true;
    })
    .catch((err) => {
      Toast.fail(err);
      return true;
    });
};

// 监控修改订单窗口的显示状态
watch(
  () => showModifyOrderBox.value,
  (val) => {
    if (val == true) {
      // 对调整参数进行赋值
      // 对象深拷贝
      submitOrderParams.examTime = JSON.parse(
        JSON.stringify(examTimeValue.value)
      );
      submitOrderParams.examScore = JSON.parse(
        JSON.stringify(examScoreValue.value)
      );
      submitOrderParams.examTime._max = orderData.value.maxExamTime;
    }
  }
);
// 倒计时开始
const startTime_ = () => {
  setTimeout(() => {
    countDown.value.start();
  }, 0);
};

// 计算走了多长时间
const remaTimeCalc = () => {
  let diffDate =
    new Date(orderData.value.targetDate.replace(/-/g, "/")).getTime() -
    new Date().getTime();
  let remaTime = orderData.value.targetExamTime - parseInt(diffDate / 1000);
  return remaTime;
};

// 监控任务状态
watch(
  () => orderData.value.taskStatus,
  (newVal) => {
    // 进行中
    if (newVal == 1) {
      // 启动倒计时
      let remaTime = remaTimeCalc();
      rate.value = 100;
      Sec = orderData.value.targetExamTime + 2; // 任务总时长 2为对位时间
      speed.value = 100 / Sec;
      time.value = (Sec - remaTime) * 1000;
      currentRate.value = (remaTime / Sec) * 100;
      startTime_();
    }
    // 已完成
    if (newVal == 2) {
      rate.value = 100;
      currentRate.value = 100;
    }
  }
);
// 秒转换为分钟和秒
const TimeToMin = (Sec) => {
  const minute = Math.floor(Sec / 60);
  const second = Sec % 60;
  return `${minute}分${second}秒`;
};

// 取出参数
let paramsOrderId = router.currentRoute.value.params.orderid;
if (paramsOrderId) {
  orderId.value = paramsOrderId;
  queryOrderInfo(paramsOrderId);
}
</script>

<style>
.van-search__content {
  align-items: center;
  border: 2px solid #e9cd8d;
  padding-left: 18px;
}
.Cell {
  align-items: center;
}
</style>
<style scoped>
.van-button--small {
  padding: 0 20px;
}

.CountDownBox {
  padding: 24px 0;
}

.CountDown {
  font-size: 58px;
  color: #676c67;
}
.van-checkbox {
  justify-content: center;
}
.inviteText {
  color: #62281d;
  font-weight: bold;
}

.invitePhone {
  position: absolute;
  bottom: 79px;
  left: 30px;
  font-size: 44px;
  font-weight: bold;
  color: #fcda69;
}
</style>
